import { render, staticRenderFns } from "./UsuariosUpdate.vue?vue&type=template&id=08363e04&"
import script from "./UsuariosUpdate.vue?vue&type=script&lang=js&"
export * from "./UsuariosUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports